import { create } from 'zustand';
import { ICreatorOnPlatformCreator } from '~/hooks/api/useGetOnPlatformCreatorByEmail';
import { ICreator } from '~/types';

export const GENERIC_ERROR = 'GENERIC_ERROR';
export const EMAIL_ALREADY_IN_AGENCY_ERROR =
  'A Talent with this email already exists in your agency.';

export enum REQUEST_TYPE {
  primaryManager = 'primaryManager',
  coManager = 'coManager',
}

export enum STEP {
  initial = 'initial',
  managed = 'managed',
  addTalentManaged = 'add-talent-managed',
  unmanaged = 'unmanaged',
  addTalentUnmanaged = 'add-talent-unmanaged',
}

type InviteCreatorStore = {
  isModalOpen: boolean;
  openModal: (options?: {
    isAddTalentFlow?: boolean;
    creatorOffPlatform?: ICreator;
    creatorOnPlatformResult?: ICreatorOnPlatformCreator;
    step?: STEP;
  }) => void;
  closeModal: () => void;

  isLoading: boolean;
  setIsLoading: (step: InviteCreatorStore['isLoading']) => void;

  step: STEP;
  setStep: (step: InviteCreatorStore['step']) => void;

  // Identifies if the talent is being invited from the AddTalent flow
  isAddTalentFlow: boolean;
  setIsAddTalentFlow: (
    isAddTalentFlow: InviteCreatorStore['isAddTalentFlow'],
  ) => void;

  requestType: string | null;
  setRequestType: (requestType: InviteCreatorStore['requestType']) => void;

  creatorOffPlatform: null | ICreator;
  setCreatorOffPlatform: (
    data: InviteCreatorStore['creatorOffPlatform'],
  ) => void;

  creatorOnPlatformResult: null | ICreatorOnPlatformCreator;
  setCreatorOnPlatformResult: (
    data: InviteCreatorStore['creatorOnPlatformResult'],
  ) => void;

  error: string | null;
  setError: (data: InviteCreatorStore['error']) => void;

  reset: () => void;
};

export const useInviteCreatorStore = create<InviteCreatorStore>((set) => ({
  isModalOpen: false,
  openModal: (options) => set({ isModalOpen: true, ...options }),
  closeModal: () => set({ isModalOpen: false }),
  step: STEP.initial,
  setStep: (step) => set({ step }),
  isAddTalentFlow: false,
  setIsAddTalentFlow: (isAddTalentFlow) => set({ isAddTalentFlow }),
  requestType: null,
  setRequestType: (requestType) => set({ requestType }),
  creatorOffPlatform: null,
  setCreatorOffPlatform: (data) => set({ creatorOffPlatform: data }),
  creatorOnPlatformResult: null,
  setCreatorOnPlatformResult: (data) => set({ creatorOnPlatformResult: data }),
  error: null,
  setError: (error) => set({ error }),
  isLoading: false,
  setIsLoading: (isLoading) => set({ isLoading }),

  // Reset
  reset: () =>
    set({
      isModalOpen: false,
      step: STEP.initial,
      requestType: null,
      isAddTalentFlow: false,
      isLoading: false,
      creatorOffPlatform: null,
      creatorOnPlatformResult: null,
      error: null,
    }),
}));
